import constants from 'constants/index'

const processChipStatusColor = (status) => {
  return (
    (status && constants.audits.DATA_PROCESS_CHIP_STATUS_COLOR[status]) ||
    undefined
  )
}

export default processChipStatusColor
